import { ClientSide } from "~/@types";
import { IInsight } from "~/@types/generated/contentful";
import InsightNavActions from "./InsightNavActions";
import InsightNavShare from "./InsightNavShare";

type InsightNavHeroProps = {
  insight: ClientSide<IInsight>;
};

export default function InsightNavHero({ insight }: InsightNavHeroProps) {
  return (
    <div className="mt-10 flex items-center justify-between">
      <div className="flex items-center gap-x-4">
        <div className="hidden lg:block">
          <InsightNavActions insight={insight} />
        </div>
      </div>
      <div>
        <InsightNavShare insight={insight} className="lgmax:hidden" />
      </div>
    </div>
  );
}
